import React from 'react';

import ErrorPage from 'components/shared/ErrorPage/ErrorPage';

const headline =
  'We are having technical issues redirecting to the Wall Street Journal.';

const WsjErrorPage = () => (
  <ErrorPage summaryMessage={headline}>
    <div className="sso-form-error-message">Please try again later.</div>
  </ErrorPage>
);

export default WsjErrorPage;
